export const fmtTRY = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(n ?? 0);

export const fmtDate = (d) => {
  if (!d) return "";
  const date = new Date(d);
  return date.toLocaleDateString("tr-TR", { day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const ORDER_STATUS_COLORS = {
  "Taslak": "bg-neutral-200 text-neutral-700",
  "Ödeme Bekliyor": "bg-amber-100 text-amber-800",
  "Ödeme Başarısız": "bg-rose-100 text-rose-800",
  "Ödeme Başarılı": "bg-blue-100 text-blue-800",
  "Hazırlanıyor": "bg-indigo-100 text-indigo-800",
  "Kargoya Verildi": "bg-teal-100 text-teal-800",
  "Teslim Edildi": "bg-emerald-100 text-emerald-800",
  "İptal Edildi": "bg-rose-100 text-rose-800",
  "İade Edildi": "bg-rose-100 text-rose-800",
  "Kargoya Hazır": "bg-cyan-100 text-cyan-800",
  "İade Talebi": "bg-orange-100 text-orange-800",
  "Sorunlu": "bg-red-100 text-red-800",
};

export const ORDER_TIMELINE = ["Ödeme Bekliyor", "Ödeme Başarılı", "Hazırlanıyor", "Kargoya Verildi", "Teslim Edildi"];
